

















import Vue, { PropType } from 'vue';

const _defaultActiveColor = ['orange', 'lighten-4'];
const _inactiveColor = ['grey', 'lighten-4'];

export interface PillConfig {
  role: string;
  roleName: string;
  activeClasses?: string[];
}

export default Vue.extend({
  props: {
    activeRoles: Array as PropType<string[]>,
    config: {
      type: Array as PropType<PillConfig[]>,
      required: true
    }
  },

  computed: {
    selection(): string[] {
      return this.activeRoles;
    },
    rolesConfig(): { role: string; roleName: string; classes: string[] }[] {
      return this.config.map(pillConfig => ({
        role: pillConfig.role,
        roleName: pillConfig.roleName,
        classes: this.activeRoles.includes(pillConfig.role)
          ? pillConfig.activeClasses ?? _defaultActiveColor
          : _inactiveColor
      }));
    }
  },

  methods: {
    onChange(role: string) {
      this.$emit('role-change', role);
    }
  }
});
